import { axiosV1 } from 'interceptors/axios';

import { Range } from 'types';
import { decryptResponse } from 'utils/token';

type GetHoldingClassAvailableRangeProps = {
  holdingClassId: string;
  sharesCount: number;
  addedRanges: Range[];
  useFirstAvailableRange: boolean;
};

export const getHoldingClassAvailableRange = async ({
  holdingClassId,
  sharesCount,
  addedRanges,
  useFirstAvailableRange = false,
}: GetHoldingClassAvailableRangeProps) => {
  const body = {
    holdingClassId,
    sharesCount,
    addedRanges,
    useFirstAvailableRange,
  };
  const { data } = await axiosV1.post('/holdingClasses/available-range', body);

  const decodedData = (await decryptResponse(data)) as Range;

  return decodedData;
};
